import { select, takeLatest } from '@redux-saga/core/effects'
import { put } from 'redux-saga/effects'
import { getEmailDetailSelector } from '../selectors/getEmailDetail.selector'
import { getEmailDetailsSelector } from '../../patientDemographics/selectors/getEmailDetails.selector'
import { setEmailDetails } from '../../patientDemographics/store/patientDemographics.actions'
import { OptionsConstants } from '../store/options.constants'
import { IEmailDetail, IEmailDetails } from '../store/options.types'

export function* deleteEmailDetails() {
  const EmailDetails: IEmailDetails = yield select(getEmailDetailsSelector)
  const EmailDetail: IEmailDetail = yield select(getEmailDetailSelector)
  if (EmailDetail && EmailDetails) {
    yield put(setEmailDetails(EmailDetails.filter((Email) => Email.key !== EmailDetail?.key)))
  }
}

export function* deleteEmailDetailsSaga() {
  yield takeLatest([OptionsConstants.DELETE_EMAIL], deleteEmailDetails)
}
